import { connect } from "react-redux"
import { Map } from "immutable"

import {
    communityParticipantListRequest,
    communityMembersAddListSearchRequest
} from "../../../../../actions/community-participant-actions"

import {
    communityCancelAddingMembers,
    communityApplyAddSelectedMembers
} from "../../../../../actions/community-actions"

import CommunityEditParticipants from "./CommunityEditParticipants"

const participantTypes = [
    { label: "Members", value: "members" },
    { label: "Managers", value: "managers" },
    { label: "Followers", value: "followers" },
    { label: "Invitation sent", value: "invited" },
    { label: "Awaiting approval", value: "awaitingApproval" }
]

const mapStateToProps = ({ presentation: { communities }, paging }, props) => {
    const participantPaging = props.isAdding
        ? paging.users
        : paging.communityParticipants[communities.selectedParticipantType]
    const searchCriteriaAccessor = props.isAdding
        ? "membersAdd"
        : communities.selectedParticipantType
    const pagingRequest =
        participantPaging[
            communities[`${searchCriteriaAccessor}SearchCriteria`]
        ] || {}
    return {
        selectedParticipantType: communities.selectedParticipantType,
        participantTypes,
        pagingRequest,
        searchTerm: communities.participantSearchTerm,
        isAdding: communities.isAddingMembers,
        canApply:
            communities.membersSelectedToAdd.length > 0 ||
            communities.membersSelectedToRemove.length > 0,
        ...props
    }
}

const mapDispatchToProps = (dispatch, { communityId }) => ({
    onTypeChange: pagingRequest => ({ target }) =>
        dispatch(communityParticipantListRequest(target.value, pagingRequest)),
    cancelAdding: () => dispatch(communityCancelAddingMembers()),
    addSelected: () => dispatch(communityApplyAddSelectedMembers()),
    onSearch: ({ target }) => {
        dispatch(
            communityMembersAddListSearchRequest(
                Map({
                    name: target.value,
                    excluding_communities: communityId
                })
            )
        )
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(
    CommunityEditParticipants
)
